// extracted by mini-css-extract-plugin
export default {"toTop":"toTop_toTop__O5V2o","toTopArrow":"toTop_toTopArrow__5uQtl"};